import React, { useState } from 'react';
import PlaylistsRow from './PlaylistsRow';

const PlaylistsToggle = ({ children, tracks, extraControls }) => {
  const [showRow, setShowRow] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'stretch', justifyContent: 'space-between', width: '100%', height: 35, marginBottom: 16 }}>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '16px' }}>
          {children}
          {extraControls}
        </div>
        <div style={{ flex: '0 0 100px', display: 'flex', alignItems: 'stretch' }}>
        <button
          className="btn-danger-custom btn-ripple"
          style={{
            cursor: 'pointer',
            width: '100%',
            height: '100%',
            margin: 0,
            padding: 0,
            alignSelf: 'stretch'
          }}
          onClick={() => setShowRow((prev) => !prev)}
        >
          <span>Playlists</span>
        </button>
        </div>
      </div>
      {showRow && <PlaylistsRow tracks={tracks} />}
    </div>
  );
};

export default PlaylistsToggle; 